// Configuration for CustomEventPopup component
export const createCustomEventPopupConfig = ({
    // Core popup state
    isOpen,
    setOpen,
    isEdit,
    saveEvent,
    onClose,
    anchor,
    
    // Event data
    popupEventTitle,
    popupEventDescription,
    popupEventAllDay,
    popupEventDate,
    selectedColor,
    isBusy,
    isX,
    isEditable,
    isChecked,
    
    // Event handlers
    titleChange,
    descriptionChange,
    allDayChange,
    changeStartDate,
    changeEndDate,
    handleEventBusy,
    handleEventX,
    handleEventInvoiced,
    handleResourceCheckInEvent,
    changeColor,
    
    // UI configuration
    headerText,
    popupButtons,
    responsivePopup,
    closeOnOverlayClick = true,
    fullScreen = true,
    
    // Resources and references
    items,
    startRef,
    endRef,
    onDelete
}) => ({
    // Core props
    isOpen,
    setOpen,
    isEdit,
    saveEvent,
    onClose,
    fullScreen,
    headerText,
    anchor,
    closeOnOverlayClick,
    
    // Event data
    popupEventTitle,
    popupEventDescription,
    popupEventAllDay,
    popupEventDate,
    selectedColor,
    isBusy,
    isX,
    isEditable,
    isChecked,
    
    // Event handlers
    titleChange,
    descriptionChange,
    allDayChange,
    changeStartDate,
    changeEndDate,
    onEventBusyChange: handleEventBusy,
    onHandleEventXChange: handleEventX,
    onHandleEventInvoicedChange: handleEventInvoiced,
    handleResourceCheckInEvent,
    changeColor,
    
    // UI configuration
    popupButtons,
    responsivePopup,
    
    // Resources and references
    items,
    startRef,
    endRef,
    onDelete
});

// Default configuration values
export const defaultCustomEventPopupConfig = {
    fullScreen: true,
    closeOnOverlayClick: true
};
